








































































import { defineComponent, Ref, ref, computed, onUnmounted, reactive } from '@vue/composition-api';
import Cookies from 'js-cookie';
import { MobileIcon, ChevronLeftIcon } from 'tdesign-icons-vue';

// 引入组件
// import loginWithApp from '@/renderer/components/login/components/loginWithApp.vue';
import InternalServer from '@/renderer/components/login/components/InternalServer.vue';
import LoginMoreEntrance from '@/renderer/components/login/components/MoreEntrance/index.vue';
import LoginMainEntrance, {
  MainEntranceComponent,
} from '@/renderer/components/login/components/MainEntrance/index.vue';
import OrgList from '@/renderer/components/user/components/OrgList.vue';
import noEnterpriseDialog from '@/renderer/components/login/components/noEnterpriseDialog.vue';

// 引入 compositions
import registerHandler from '@/renderer/components/user/compositions/registerHandler';

// 引入工具类
import { IpcEvents } from '@/ipc-events';
import { getChannel, checkIsOauth2 } from '@/renderer/scripts/composition/channel';
import { IS_PRIVATE, IS_BROWSER } from '@/common/constant/platform';
import tips from '@/renderer/scripts/utils/tips';
import { httpUrl } from '@/renderer/scripts/http';
import { protocolUrlMap } from '@/common/constant';
import smh from '@/renderer/scripts/smh';
import ipc from '@/renderer/scripts/utils/ipc';
import user, { User } from '@/renderer/scripts/utils/user';
import { LoginTypeKeyMap, LoginActionKeyMap } from '@/renderer/scripts/utils/user/UserTypingMap';
import storage from '@/renderer/scripts/utils/storage';
import { getUrlQuery } from '@/renderer/scripts/utils/tools';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import {
  chooseOrgLogin,
  loginWithWechatCode,
  loginWithWecomCode,
  loginWithCookie,
  loginWithSSOCode,
  verifyAccountLogin,
  loginOauth2WithCookie,
} from '@/renderer/scripts/utils/user/userLogin';
import { meetingLoginFn } from '@/renderer/scripts/utils/meeting/autoLoginInMeeting';
import vistor from '@/renderer/scripts/utils/vistor';
import meeting from '@/renderer/scripts/utils/meeting';
import i18n, { i18n_t } from '@/locales/i18n';
import { windowEnvs } from '@/renderer/scripts/utils/ConstantConfig/PrivateConfig';

interface PullAppParams {
  code: string;
  state: string;
  ssoWay: string;
}
const doAsyn = require('@tencent/do-asyn');

export default defineComponent({
  name: 'Login',
  components: {
    noEnterpriseDialog,
    OrgList,
    InternalServer,
    MobileIcon,
    ChevronLeftIcon,
    LoginMoreEntrance,
    LoginMainEntrance,
  },
  props: {
    isOauth: {
      type: Boolean,
      default: false,
    },
    vistorLogin: {
      type: Boolean,
      default: false,
    },
    hideMoreLoginMethods: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const vm = context.root;
    const store = vm.$store;
    const mainEntranceRef = ref<MainEntranceComponent | null>(null);

    const showVistorLogin = ref(false);

    const { isTMWebview } = meeting;

    const loginWay = ref<User.LoginTypeKey>(User.LoginTypeKey.loginWithPhone);
    const showProductLogo = ref(true);

    // 正在展示选择企业列表
    const selectingOrg = ref(false);
    const selectingOrgList: Ref<CoFile.OrgItem[]> = ref([]);
    const isShare = computed(() => vm.$route.name === 'share' && !store.getters.onlyPasswordLogin);

    const showInternalServerForm = ref(IS_PRIVATE && !IS_BROWSER && !httpUrl.internalSMHHost);

    const isMobile = computed(() => {
      const { isMobile, isMobileStyle } = store.getters;
      return isMobile || isMobileStyle;
    });

    // 是否展示更多登录方式入口
    const showMoreLoginEntry = computed(() => {
      const { loginAction, isInWeMeetApp } = store.getters;
      const isBindPhone = loginAction === User.LoginActionKey.bindPhone;
      const isLoginWithPassword = windowEnvs.loginMainEntrance.includes(User.LoginTypeKey.loginWithPassword);
      const showInShareRoute =
        vm.$route.name === 'share' && !isLoginWithPassword && !props.hideMoreLoginMethods && !selectingOrg.value;
      return (
        (!isBindPhone &&
          !isInWeMeetApp &&
          !props.isOauth &&
          !props.vistorLogin &&
          !props.hideMoreLoginMethods &&
          !selectingOrg.value &&
          !showInternalServerForm.value &&
          windowEnvs.loginMoreEntrance.length > 0) ||
        showInShareRoute
      );
    });
    const loginHeight = computed(() => {
      let height = 410;
      const renderLoginMainEntranceTabs = mainEntranceRef.value?.renderLoginMainEntranceTabs || [];
      if (renderLoginMainEntranceTabs?.length === 0) {
        height = 380;
        if (store.getters.loginAction === LoginActionKeyMap.bindPhone) {
          height = 412;
        }
      } else if (renderLoginMainEntranceTabs?.length === 1) {
        height = 380;
      } else if (renderLoginMainEntranceTabs?.length > 1) {
        height = 410;
      }
      if (store.getters.selectOrgBeforeLogin) {
        height += 44;
      }
      if (showMoreLoginEntry.value) {
        height += 98;
      } else {
        height += 52;
      }
      if (store.getters.isInWeMeetApp) {
        height = 420;
      }
      context.emit('onHeightChange', height);
      return `${height}px`;
    });

    const showNoEnterpriseDialog = ref(false);
    const bindInfo = reactive({
      code: '',
      phoneNumber: '',
      sms: '',
      wechatCode: '',
    });

    const { showCancelDeregiseterDialog, showFreezeDialog, showIPRestrictDialog } = registerHandler();

    const methods = {
      initData() {
        methods.initLoginType();
        methods.initUserInfo();
        methods.redirectOrLogin();
        methods.getCorpList();
      },
      initLoginType() {
        const { force_login: forceLoginType, tab } = vm.$route.query;
        if (
          IS_PRIVATE &&
          forceLoginType &&
          forceLoginType === User.LoginTypeKey.loginWithPhone &&
          !windowEnvs.loginMainEntrance.includes(forceLoginType)
        ) {
          windowEnvs.loginMainEntrance.push(forceLoginType);
        }

        // 登录方式 该展示哪种登录组件
        if (
          tab &&
          typeof tab === 'string' &&
          [...windowEnvs.loginMainEntrance, ...windowEnvs.loginMoreEntrance].includes(
            tab as User.LoginMainEntrance | User.LoginMoreEntrance,
          )
        ) {
          loginWay.value = tab as User.LoginMainEntrance | User.LoginMoreEntrance;
        } else if (isTMWebview) {
          loginWay.value = User.LoginTypeKey.loginWithMeetingPhone;
        } else if (store.getters.isTclApp) {
          loginWay.value = User.LoginTypeKey.loginWithWechat; // TCL平板默认使用扫码登录
        } else if (IS_PRIVATE) {
          if (windowEnvs.loginMainEntrance.includes(User.LoginTypeKey.loginWithPassword)) {
            loginWay.value = User.LoginTypeKey.loginWithPassword; // 配置中有账密登录则默认账密登录
          } else if (windowEnvs.loginMainEntrance.includes(User.LoginTypeKey.loginWithIOA)) {
            loginWay.value = User.LoginTypeKey.loginWithIOA; // 配置中有IOA登录则默认IOA登录
          } else if (props.vistorLogin) {
            loginWay.value = User.LoginTypeKey.loginWithPhone;
          } else if (windowEnvs.loginMainEntrance.length === 1) {
            const [loginType] = windowEnvs.loginMainEntrance;
            loginWay.value = loginType as User.LoginMainEntrance;
          }
        }
      },
      initUserInfo() {
        if (vm.$route.name === 'login' && !vm.$route.query?.code) {
          user.resetLoginInfo();
        }
      },
      changeLoginTypeInMainEntrance(type: User.LoginTypeKey) {
        user.setLoginType(type, true);
        loginWay.value = type;
      },
      changeLoginTypeInMoreEntrance(type: User.LoginTypeKey | 'visitor') {
        if (type === 'visitor') {
          showVistorLogin.value = true;
          loginWay.value = User.LoginTypeKey.loginWithPhone;
          return;
        }
        const valid = mainEntranceRef.value?.validate() || store.getters.approvedAgreement;
        if (!valid) return;

        showVistorLogin.value = false;
        loginWay.value = type;
      },
      // 会议里切换会议登录/手机号登录
      toggleMeetingPhoneLogin() {
        if (loginWay.value === User.LoginTypeKey.loginWithMeetingPhone) {
          loginWay.value = User.LoginTypeKey.loginWithPhone;
        } else {
          loginWay.value = User.LoginTypeKey.loginWithMeetingPhone;
        }
      },

      // 身份注销中弹窗
      orgDeregisteredHandler({ orgId, editionFlag, cb }: { orgId: number; editionFlag: string; cb: Function }) {
        methods.restore();
        showCancelDeregiseterDialog(orgId, editionFlag, cb);
      },
      // 身份冻结中弹窗
      orgFreezedHandler({ editionFlag }: { editionFlag: string }) {
        methods.restore();
        showFreezeDialog(editionFlag);
      },
      orgIPRestrictedHandler({ isInvitation }: { isInvitation: boolean }) {
        methods.restore();
        showIPRestrictDialog(isInvitation);
      },
      restore() {
        tips.closeAll();
        selectingOrg.value = false;
        if (isTMWebview) {
          loginWay.value = User.LoginTypeKey.loginWithMeetingPhone;
        } else if (store.getters.isTclApp) {
          loginWay.value = User.LoginTypeKey.loginWithWechat; // TCL平板默认使用扫码登录
        } else if (IS_PRIVATE) {
          if (windowEnvs.loginMainEntrance.includes(User.LoginTypeKey.loginWithPassword)) {
            loginWay.value = User.LoginTypeKey.loginWithPassword; // 配置中有账密登录则默认账密登录
          } else if (windowEnvs.loginMainEntrance.includes(User.LoginTypeKey.loginWithIOA)) {
            loginWay.value = User.LoginTypeKey.loginWithIOA; // 配置中有IOA登录则默认IOA登录
          } else if (props.vistorLogin) {
            loginWay.value = User.LoginTypeKey.loginWithPhone;
          } else if (windowEnvs.loginMainEntrance.length === 1) {
            const [loginType] = windowEnvs.loginMainEntrance;
            loginWay.value = loginType as User.LoginMainEntrance;
          }
        } else {
          loginWay.value = mainEntranceRef.value?.radioGroupLoginType || User.LoginTypeKey.loginWithPhone;
        }
        user.resetLoginInfo();
      },
      // 需要初始化密码时，隐藏logo；否则要显示
      tiggerShowLogoInLoginWithPassword(show: boolean) {
        showProductLogo.value = show;
      },
      async showLoginOrgList() {
        tips.closeAll();
        const { organizations } = user.getUserInfoSync();
        selectingOrgList.value = organizations as CoFile.OrgItem[];
        selectingOrg.value = true;
      },
      hideLoginOrgList() {
        selectingOrg.value = false;
      },
      // 取消选择企业
      cancelSelectOrg() {
        selectingOrg.value = false;
        user.signOut();
      },
      loginWithWechatFn({ code = '' }) {
        user.setAuthCode(code as string);
        const { channelTag } = getChannel();
        loginWithWechatCode({
          code,
          channelTag,
        });
      },
      loginWithWecomFn({ code = '', appid = '', realdomain = '' }) {
        user.setAuthCode(code as string);
        loginWithWecomCode({
          code,
          appid,
          realdomain,
        });
      },

      // yufu登录
      loginWithYufuFn({ code = '', state = '' }) {
        const [, tenantKey, type] = state.split('_');
        user.setTenantKey(tenantKey);
        user.setTenantType(type);
        user.setAuthCode(code as string);
        loginWithSSOCode({
          tenantKey,
          code,
          type,
        });
      },

      // sso登录
      loginWithSSOFn({ credential = '' }) {
        const { corpid } = user.getUserInfo();
        verifyAccountLogin({
          type: 'sso',
          credential,
          orgDomain: corpid,
        });
      },

      // pc端微信、企微登录、sso登录实现
      loginWithCode(e: any, { type = '', appid = '', realdomain = '', code = '', state = '', ticket = '' }) {
        tips.loading(i18n_t('正在登录'), 0);
        if (type === 'wechat') {
          methods.loginWithWechatFn({
            code,
          });
        } else if (type === 'wecom') {
          methods.loginWithWecomFn({
            code,
            appid,
            realdomain,
          });
        } else if (type === 'yufu') {
          methods.loginWithYufuFn({ code, state });
        } else if (type === 'sso') {
          methods.loginWithSSOFn({ credential: ticket || code });
        }
      },
      // 拉起 ios、android 网盘 app
      pullMobileApp(params: PullAppParams) {
        // @ts-ignore
        doAsyn.gj(() => {
          // @ts-ignore
          TcsJSBridge.invoke('privateSSOCallback', params, () => {
            logger.ui('移动端接收到oauth登录参数...');
          });
        });
      },
      // 自动登录处理
      async autoLoginInBrowser() {
        // 腾讯会议里进入自动登录
        const { isLogout, code, ticket, state, needSelectOrg } = vm.$route.query; // 主动退出到登录页

        // 腾讯会议里
        if (isTMWebview) {
          if (needSelectOrg) {
            // 会议里需要在登录页展示企业列表
            methods.showLoginOrgList();
          } else if (!isLogout) {
            // 自动登录
            store.commit('setLoginingMask', true);
            loginWay.value = User.LoginTypeKey.loginWithMeeting;
            meetingLoginFn({ loginToPath: '', showTip: false, callback: (params: any) => dispatchRouter(params) });
          }
          return;
        }

        // sso--cas协议登录 优先级大于恢复本地登录态 用于唤起pc端
        if (ticket) {
          const ua = navigator?.userAgent || '';
          if (ua === 'TCED_WEBVIEW') {
            // 交给webview处理pc端登录
            return;
          }
          const ticketStr = ticket as string;
          // 区分是来自web还是pc
          const { ssoFrom } = user.getUserInfo();
          if (ssoFrom === 'web') {
            store.commit('setLoginingMask', true);
            methods.loginWithSSOFn({ credential: ticketStr });
          } else {
            // 唤起移动端应用
            methods.pullMobileApp({ code: ticketStr, state: state as string, ssoWay: 'cas' });
          }
          return;
        }

        // 判断是否oauth/oidc登录
        if (code && state && state.includes('_') && (state as string).startsWith('oauth_')) {
          const ua = navigator?.userAgent || '';
          if (ua === 'TCED_WEBVIEW') {
            // 交给webview处理pc端登录
            return;
          }

          const [type, version, from, custom_state] = (state as string).split('_');
          // oauth/oidc登录
          if (from === 'web') {
            store.commit('setLoginingMask', true);
            methods.loginWithSSOFn({ credential: code as string });
          } else if (from === 'pc') {
            const url = `${protocolUrlMap.ssoLogin}?code=${code}&state=${state}`;
            const frame = document.createElement('iframe');
            frame.src = url;
            frame.style.display = 'none';
            document.body.appendChild(frame);
          } else if (['android', 'ios'].includes(from)) {
            // 安卓、ios端内执行回调
            // @ts-ignore
            doAsyn.gj(() => {
              // @ts-ignore
              TcsJSBridge.invoke('privateSSOCallback', { code, state }, res => {
                logger.ui('移动端接收到oauth登录参数...');
              });
            });
          }
          return;
        }

        // web端访问登录页取登录态自动登录
        if (!isTMWebview && Cookies.get('USER_TOKEN')) {
          const userData = storage.get(storage.StoreKey.TCD_USER_INFO) as User.UserInfo;
          const isOauth2 = checkIsOauth2();
          // oauth2恢复登录态
          if (isOauth2 && (userData.baseInfo.userId as number) > 0) {
            store.commit('setLoginingMask', true);
            loginOauth2WithCookie();
            return;
          }
          // 只有完全登录进企业的登录态才能自动登录
          if (userData?.baseInfo?.isLogined) {
            store.commit('setLoginingMask', true);
            loginWithCookie();
            return;
          }
        }

        // 微信、企微扫码登录
        if (code) {
          const { appid = '', realdomain = '' } = vm.$route.query;
          const codeStr = code as string;
          const appidStr = appid as string;
          const realdomainStr = realdomain as string;
          store.commit('setLoginingMask', true);
          user.setAuthCode(code as string);
          if (state && typeof state === 'string') {
            if (state.startsWith('wxlogin_')) {
              methods.loginWithWechatFn({
                code: codeStr,
              });
            } else if (state.startsWith('wwlogin_')) {
              methods.loginWithWecomFn({
                code: codeStr,
                appid: appidStr,
                realdomain: realdomainStr,
              });
            } else if (state.startsWith('yufulogin_')) {
              methods.loginWithYufuFn({
                code: codeStr,
                state,
              });
            }
          }
        }
      },
      // 重定向或自动登录
      redirectOrLogin() {
        // 微信扫码、企业微信扫码登录需要从公共域名跳转到自定义域名
        if (!store.getters.isBrowser) return;
        if (vm.$router.currentRoute.name !== 'login' && vm.$router.currentRoute.name !== 'collect') return;
        const { href } = window.location;
        const queryResult = getUrlQuery(href);
        const { query } = queryResult;
        const { auth2_state, channel_flag } = query;
        if ((query.domain && query.code) || auth2_state) {
          store.commit('setLoginingMask', true);
          let url = `${query.domain}/login?code=${query.code}&state=${query.state || ''}&appid=${
            query.appid || ''
          }&path=${query.path || ''}${query.realdomain ? `&realdomain=${query.realdomain}` : ''}`;
          if (auth2_state) {
            const { app_id, redirect_uri, scope, auth2_state, response_type } = query;
            url += `&oauth2=1&app_id=${app_id}&redirect_uri=${redirect_uri}&scope=${scope}&oauth_state=${auth2_state}&channel_flag=${channel_flag}&response_type=${response_type}`;
          }
          dispatchRouter(url, 'location');
        } else {
          methods.autoLoginInBrowser();
        }
      },
      // 完成登录
      async afterLogined() {
        let loginPath = vm.$route.query.path || '/login';
        const { auth2_state, code, state, ticket } = vm.$route.query;
        if (auth2_state) {
          const { app_id, redirect_uri, scope, auth2_state, response_type } = vm.$route.query;
          loginPath = `/login?oauth2=1&app_id=${app_id}&redirect_uri=${redirect_uri}&scope=${scope}&state=${auth2_state}&response_type=${response_type}`;
        }
        if (code && state && state.includes('_') && (state as string).startsWith('oauth_')) {
          const [type, version, from, custom_state] = (state as string).split('_');
          if (custom_state) {
            loginPath = custom_state;
          }
        } else if (ticket) {
          // cas 登录信息
          const { path = '', time }: { path: string; time: number } = storage.get(storage.StoreKey.CAS_LOGIN);
          if (path && Date.now() - time < 1000 * 60 * 60) {
            // 一小时有效期
            loginPath = path;
          }
          storage.del(storage.StoreKey.CAS_LOGIN);
        }
        const { orgExpired } = store.getters;
        try {
          if (!orgExpired) {
            // 登录的企业过期时不能查询个人空间
            const { data } = await smh.userAPI.hasPersonalSpace();
            vm.$store.commit('SET_PERSONAL_SPACE', data.hasPersonalSpace); // 登录成功立即保存，以便在保存网盘处，及时判断显示对应空间
          }

          if (vm.$route.name === 'share') {
            // 分享页登录后上报
            reporter.report('link_view', {
              link_view_login: '1',
            });
          }
          // 避免登录后判断loginPath出问题
          if (loginPath.includes('isLogout=1')) {
            loginPath = '/login';
          }
          context.emit('logined', {
            loginPath,
          });
        } catch (e: any) {
          tips.error(e);
        }
      },
      // 完成游客登录
      afterVistorLogin() {
        context.emit('vistorLogined');
      },
      openNoEnterpriseDialog(params: { code: string; phoneNumber: string; sms: string; wechatCode?: string }) {
        Object.assign(bindInfo, params);
        showNoEnterpriseDialog.value = true;
      },
      // 私有化下查询当前企业列表
      getCorpList() {
        if (store.getters.isPrivate) {
          store.dispatch('getCorpList');
        }
      },
      cancelVisitorLogin() {
        showVistorLogin.value = false;
        // @ts-ignore
        if (!windowEnvs.loginMainEntrance.includes(loginWay.value)) {
          methods.initLoginType();
        }
      },
      ssoWebviewLogin({ ticket, code, state }: { ticket?: string; code?: string; state?: string }) {
        if (ticket) {
          methods.loginWithCode(null, { type: 'sso', ticket });
        } else {
          methods.loginWithCode(null, { type: 'sso', code, state });
        }
      },
    };

    methods.initData();

    ipc.on(IpcEvents.LOGIN_CODE, methods.loginWithCode);
    ipc.on(ipc.RENDERER_EVENTS_MAP.SHOW_NO_ENTERPRISE_DIALOG, methods.openNoEnterpriseDialog);
    ipc.on(ipc.RENDERER_EVENTS_MAP.SSO_WEBVIEW_LOGIN, methods.ssoWebviewLogin);
    user.on('show-org-list', methods.showLoginOrgList);
    user.on('org-deregistered', methods.orgDeregisteredHandler);
    user.on('org-freezed', methods.orgFreezedHandler);
    user.on('logined', methods.afterLogined);
    vistor.on('after-vistor-login', methods.afterVistorLogin);
    user.on('login-failed', methods.restore);
    user.on('org-ip-restricted', methods.orgIPRestrictedHandler);
    httpUrl.on(httpUrl.EVENT_MAP.SMHHostChanged, methods.getCorpList);

    onUnmounted(() => {
      ipc.off(IpcEvents.LOGIN_CODE, methods.loginWithCode);
      ipc.off(ipc.RENDERER_EVENTS_MAP.SHOW_NO_ENTERPRISE_DIALOG, methods.openNoEnterpriseDialog);
      ipc.off(ipc.RENDERER_EVENTS_MAP.SSO_WEBVIEW_LOGIN, methods.ssoWebviewLogin);
      user.off('show-org-list', methods.showLoginOrgList);
      user.off('org-deregistered', methods.orgDeregisteredHandler);
      user.off('org-freezed', methods.orgFreezedHandler);
      user.off('org-ip-restricted', methods.orgIPRestrictedHandler);
      user.off('logined', methods.afterLogined);
      vistor.off('after-vistor-login', methods.afterVistorLogin);
      user.off('login-failed', methods.restore);
      httpUrl.off(httpUrl.EVENT_MAP.SMHHostChanged, methods.getCorpList);
    });
    return {
      LoginTypeKeyMap,
      mainEntranceRef,
      loginHeight,

      isShare,
      loginWay,
      // showLoginTypeSelector,
      showVistorLogin,
      selectingOrg,
      selectingOrgList,
      showMoreLoginEntry,
      showInternalServerForm,
      showProductLogo,

      showNoEnterpriseDialog,
      bindInfo,
      ...methods,
      chooseOrgLogin,
    };
  },
});
